import { Category } from "./category.model";
import {Post} from "./post.model";
import {SubProduct} from "./subProduct.model";

export interface IPostSubProducts{
  id?: number;
  post?: Post;
  category?: Category;
  subProduct?: SubProduct;
  allowPaymentOnShipping?: boolean;
  allowDelivery?: boolean;
  pickFormShop?: boolean;
  deliveryDelay?: string;
  unitDeliveryDuration?: string;
  price?: number;
  finalPrice?: any;
  photo?: string;
}

export class PostSubProducts implements IPostSubProducts{
  constructor(
    public id?: number,
    public post?: Post,
    public category?: Category,
    public subProduct?: SubProduct,
    public allowPaymentOnShipping?: boolean,
    public allowDelivery?: boolean,
    public pickFormShop?: boolean,
    public deliveryDelay?: string,
    public unitDeliveryDuration?: string,
    public price?: number,
    public finalPrice?: DoubleRange,
    public photo?: string,
  ) {
    this.id = id;
    this.post = post;
    this.category = category;
    this.subProduct = subProduct;
    this.allowDelivery = allowDelivery;
    this.allowPaymentOnShipping = allowPaymentOnShipping;
    this.pickFormShop = pickFormShop;
    this.deliveryDelay = deliveryDelay;
    this.unitDeliveryDuration = unitDeliveryDuration;
    this.price = price;
    this.finalPrice = finalPrice;
    this.photo = photo;
  }
}

